import React from "react";
import { CtaButton } from "../CtaButton";
import { Icon } from "../Icon";
import { SectionHeading } from "../SectionHeading";
import { painPoints } from "../../data/content";
export function PainPoints() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-251" data-mp="27nc5c6ajovea">
      <div className="mx-auto max-w-5xl" data-id="element-252" data-mp="22vu7vs7qdcy2">
        <SectionHeading eyebrow="Does any of this sound familiar?" title={<>If you recognize yourself here, I created this <em className="text-forest" data-id="element-254" data-mp="2hmb6z4ww7qrs">with you in mind</em></>} data-id="element-253" data-mp="22usl4qhcr20i" />

        <ul className="mt-10 grid gap-x-10 gap-y-7 md:grid-cols-2" data-id="element-255" data-mp="2ckvjl678t868">
          {painPoints.map(p => <li key={p.title} className="flex gap-4" data-id="element-256" data-mp="2qkdfe5iyhlp3">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-goldSoft text-gold" data-id="element-257" data-mp="2mj1jxjdei68z">
                <Icon name={p.icon} className="h-6 w-6" data-id="element-258" data-mp="w7x0kgc3gz8m" />
              </span>
              <div data-id="element-259" data-mp="s624bq90tc1p">
                <h3 className="text-[17px] font-bold leading-snug text-ink" data-id="element-260" data-mp="s6vb2r7zc1ju">{p.title}</h3>
                <p className="mt-1.5 text-[16px] leading-relaxed text-muted" data-id="element-261" data-mp="1n8uyghh7qdwi">{p.text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-14 max-w-3xl rounded-3xl bg-sage p-7 text-center sm:p-10" data-id="element-262" data-mp="1s4jzyqcsm4vg">
          <h3 className="font-serif text-[26px] font-bold leading-tight text-forestDark sm:text-4xl" data-id="element-263" data-mp="1x3wpjiv1tq1q">
            And It Doesn't Have to Be This Complicated.
          </h3>
          <div className="mt-4 space-y-3 text-[17px] leading-relaxed text-ink/80" data-id="element-264" data-mp="26v9dw0hn1y30">
            <p data-id="element-265" data-mp="2awcw2tn5s67e">The problem isn't necessarily that you need more information.</p>
            <p data-id="element-266" data-mp="2fvz48oo4qw9c">Sometimes, what you need is a <strong className="text-ink" data-id="element-267" data-mp="2fx0jl5c6i4wv">ready-made system that organizes the learning process for you.</strong></p>
            <p data-id="element-268" data-mp="2kusjalj2evbm">That's why I created the Biomagnetism Protocol Vault™ — six practical volumes, each with a specific purpose.</p>
            <p className="font-semibold text-forest" data-id="element-269" data-mp="qhjbcy663hvh">You don't have to design your own system. You can start by following one that's already organized.</p>
          </div>
        </div>

        <div className="mt-10" data-id="element-270" data-mp="iioda68uwo59">
          <CtaButton label="Show me the complete system" data-id="element-271" data-mp="efrnnvkwfrrt" />
        </div>
      </div>
    </section>;
}